import Chip, { ChipProps } from "@mui/material/Chip";
import { useTranslation } from "react-i18next";

import { BookingFollowUpStatus } from "../../process/types/processTypes";

const STATUS_COLOR: Record<BookingFollowUpStatus, ChipProps["color"]> = {
  [BookingFollowUpStatus.new]: "default",
  [BookingFollowUpStatus.booked_with_date]: "info",
  [BookingFollowUpStatus.confirmed_by_employee]: "warning",
  [BookingFollowUpStatus.employee_completed]: "success",
  [BookingFollowUpStatus.embassy_in_progress]: "info",
  [BookingFollowUpStatus.embassy_returned]: "error",
  [BookingFollowUpStatus.embassy_stamped]: "success",
  [BookingFollowUpStatus.lmis_saved]: "info",
  [BookingFollowUpStatus.lmis_issued]: "success",
};

interface Props {
  status?: BookingFollowUpStatus;
  size?: ChipProps["size"];
}

export function FollowUpStatusChip({ status, size = "small" }: Props) {
  const { t: te } = useTranslation("enums");
  const value = status ?? BookingFollowUpStatus.new;
  const isDefault = value === BookingFollowUpStatus.new;

  return (
    <Chip
      label={te(`bookingFollowUp_${value}`)}
      color={STATUS_COLOR[value]}
      variant={isDefault ? "outlined" : "filled"}
      size={size}
      sx={{ fontWeight: 600, fontSize: "0.7rem" }}
    />
  );
}
